import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';
import { LOGO_URL } from '../data/constants';
import { getWhatsAppUrl } from '../utils/whatsapp';
import { Menu, X, MessageCircle } from 'lucide-react';
export const Header = () => {
  const {
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#inicio',
    label: t('nav.home')
  }, {
    href: '#barcos',
    label: t('nav.boats')
  }, {
    href: '#premium',
    label: t('nav.premium')
  }, {
    href: '#motos',
    label: t('nav.jetski')
  }, {
    href: '#licencias',
    label: t('nav.licenses')
  }, {
    href: '#como-funciona',
    label: t('nav.howItWorks')
  }];
  const handleWhatsAppClick = () => {
    const message = t('wa.help');
    window.open(getWhatsAppUrl(message), '_blank');
  };
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#001040]/95 backdrop-blur-md shadow-lg py-3' : 'bg-[#001040] py-4'}`} data-id="element-301" data-mp="2mohua0j1bddn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302" data-mp="3fdf0h59z1jq1">
        <div className="flex justify-between items-center" data-id="element-303" data-mp="3adan3o4d1541">
          {/* Logo */}
          <a href="#inicio" className="flex-shrink-0" data-id="element-304" data-mp="35kr4uduq9lsw">
            <img src={LOGO_URL} alt="Kevin Boats" className="h-14 md:h-16 lg:h-20 object-contain" data-id="element-305" data-mp="35j6buso2aax5" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8 mx-6" data-id="element-306" data-mp="1yag2i0dgx8t">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-white/90 hover:text-turquoise transition-colors text-sm font-medium whitespace-nowrap tracking-wide" data-id="element-307" data-mp="1rdth0a33spb8">
                {link.label}
              </a>)}
          </nav>

          {/* Right Actions */}
          <div className="hidden lg:flex items-center space-x-3" data-id="element-308" data-mp="1mljruw9tbta0">
            <LanguageSwitcher data-id="element-309" data-mp="18mk3zqu4jiew" />
            <button onClick={handleWhatsAppClick} className="bg-turquoise hover:bg-turquoise-dark text-navy font-bold py-2 px-4 rounded-full transition-all transform hover:scale-105 flex items-center space-x-1.5 text-xs uppercase tracking-wide" data-id="element-310" data-mp="18mafy8sn3lbu">
              <MessageCircle className="w-3.5 h-3.5" data-id="element-311" data-mp="13p1t3uwjqt49" />
              <span data-id="element-312" data-mp="2t2x6xigc0rv8">{t('header.reserve')}</span>
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden flex items-center space-x-3" data-id="element-313" data-mp="2y2jjdpoc642z">
            <LanguageSwitcher data-id="element-314" data-mp="2xznne6w1tph6" />
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} className="text-white w-11 h-11 -mr-2 flex items-center justify-center" data-id="element-315" data-mp="me502mxq6hoa">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-316" data-mp="rdrciu5qbtw1" /> : <Menu className="w-6 h-6" data-id="element-317" data-mp="rc6id5nbucyp" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 w-full bg-[#001040] border-t border-white/10 shadow-xl" data-id="element-318" data-mp="1051g7eagt6eg">
          <div className="px-4 py-6 flex flex-col space-y-4" data-id="element-319" data-mp="1f2ttdzsjhiph">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white text-lg font-medium py-2 border-b border-white/5" data-id="element-320" data-mp="1a50mf4jewko5">
                {link.label}
              </a>)}
            <button onClick={() => {
          handleWhatsAppClick();
          setIsMobileMenuOpen(false);
        }} className="bg-turquoise text-navy font-bold py-3 px-6 rounded-full w-full mt-4 flex justify-center items-center space-x-2 uppercase tracking-wide text-sm" data-id="element-321" data-mp="22yfc044oo87u">
              <MessageCircle className="w-5 h-5" data-id="element-322" data-mp="1k8fovmsel372" />
              <span data-id="element-323" data-mp="1k9qs9lhxs8xn">{t('header.reserve')}</span>
            </button>
          </div>
        </div>}
    </header>;
};